module.exports = __webpack_public_path__ + "media/images/flags/MK-e414a84641a88ed84a2f3f950c1ef194.svg";